import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 16"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#797979",
  "fill-rule": "evenodd",
  d: "M12.204 1.967a1.467 1.467 0 0 0-2.934 0v3.046h-.45a.559.559 0 1 0 0 1.117h3.833a.559.559 0 1 0 0-1.117h-.45zM9.042 3.789l-3.277.387q-.132.029-.272.032h-.039C4.65 4.209 4 3.575 4 2.792c0-.782.65-1.417 1.454-1.417l.059.001h.009q.2.01.383.07l3.137.557zm6.67-2.363-3.28.387V3.6l3.135.558q.185.06.388.069l.007.001v-.001l.059.001c.803 0 1.454-.634 1.454-1.417s-.651-1.417-1.454-1.417h-.043a1.5 1.5 0 0 0-.265.032m-1.886 5.51A1 1 0 0 0 13 6.5H8a1 1 0 0 0-.826.436c-.136.199-.333.382-.574.382H5a5 5 0 0 0-5 5V15a.5.5 0 0 0 .5.5h4A.5.5 0 0 0 5 15v-1.5a2 2 0 0 1 2-2h.072c.154 0 .296.075.415.173.542.45 1.726.762 3.098.762 1.373 0 2.557-.312 3.1-.762a.66.66 0 0 1 .413-.173H16.5a.5.5 0 0 1 .5.5.5.5 0 0 0 1 0V7a.5.5 0 0 0-1 0 .32.32 0 0 1-.318.318H14.4c-.241 0-.438-.183-.574-.382",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "icon-faucet"}) } }